import {Box, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Stack, Tooltip, Typography} from "@mui/material";
import {Navigate, NavLink, Outlet, useNavigate, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import {appStyles, hintColor} from "../../../AppStyles.ts";

// TODO: Replace with real counts loaded from API
function createSampleCounts() {
    return {
        summary: 0,
        details: 0,
        timeline: 0,
        web: 0,
        pages: 0,
        series: 0,
        contentResources: 0,
        metadata: 0,
        words: 0,
        assoc: 0,
        resources: 0,
        intelRef: 0,
        insight: 0,
        factors: 0,
        enrichment: 0,
        research: 0,
        provenance: 0,
        transactions: 0,
    };
}

function NavCount({ count }: { count: number }) {
    return (
        <Typography component="span" sx={appStyles.leftNavItemCount}>
            {count}
        </Typography>
    );
}

function UXResourceViewer() {
    const { networkUID, typeKey, defKey, matchHash } = useParams();
    const navigate = useNavigate();
    const counts = createSampleCounts();

    // TODO: Implement graph navigation
    const onGraph = () => {
        navigate(`/networks/${networkUID}/graph`);
    };

    // TODO: Implement original artifact download
    const onDownload = () => {
        console.log("DOWNLOAD::ORIGINAL::" + matchHash);
    };

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%" >
                    <WidgetHeader
                        title={`Resource: ${typeKey}-${defKey}-${matchHash}`}
                        breadcrumbs={[
                            { display: "Networks", linkTo: `/networks/`, activeView: false },
                            { display: String(networkUID), linkTo: `/networks/${networkUID}`, activeView: false },
                            { display: "Resources", linkTo: `/networks/${networkUID}`, activeView: false },
                            { display: String(typeKey).charAt(0).toUpperCase() + String(typeKey).slice(1), linkTo: `/networks/${networkUID}`, activeView: false },
                            { display: String(defKey).charAt(0).toUpperCase() + String(defKey).slice(1), linkTo: `/networks/${networkUID}/resources/${typeKey}/${defKey}`, activeView: false },
                            { display: String(matchHash), linkTo: "", activeView: true },
                        ]}
                    />
                    <Stack direction="row" spacing={1} alignItems="stretch" width="100%" height="100%">
                        <Stack sx={appStyles.resourceLeftNav} direction="column" height="100%">
                            <Stack
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingTop: "10px",
                                }}
                            >
                                <img
                                    src="/images/default_network_image.png"
                                    height={128}
                                    style={{
                                        display: "block",
                                        width: "auto",
                                        maxWidth: "none",
                                    }}
                                    alt=""
                                    aria-hidden="true"
                                />
                                <img
                                    src="/images/file_type/file_format_pdf.svg"
                                    height={48}
                                    style={{
                                        position: "absolute",
                                        top: "6px",
                                        left: "calc(50% - 85px)",
                                        zIndex: 2,
                                        pointerEvents: "none",
                                    }}
                                    alt=""
                                    aria-hidden="true"
                                />
                            </Stack>
                            <Stack
                                sx={appStyles.internalResourceLeftNav}
                                direction="column"
                                height="100%"
                            >
                                <Stack sx={appStyles.leftNavInner}>
                                    <Stack direction="row" spacing={1} justifyContent="center" sx={{paddingTop: "12px"}}>
                                        <Tooltip title="Go to Graph" placement="bottom">
                                            <Box
                                                component="button"
                                                sx={{...appStyles.leftNavGraphButton, padding: "6px 10px"}}
                                                onClick={onGraph}
                                            >
                                                <img
                                                    src="/images/graph_white.svg"
                                                    alt="Graph"
                                                    width={20}
                                                    height={20}
                                                />
                                            </Box>
                                        </Tooltip>
                                        <Tooltip title="Download Original" placement="bottom">
                                            <Box
                                                component="button"
                                                sx={{...appStyles.leftNavGraphButton, padding: "6px 10px"}}
                                                onClick={onDownload}
                                            >
                                                <img
                                                    src="/images/export.svg"
                                                    alt="Download Original"
                                                    width={20}
                                                    height={20}
                                                />
                                            </Box>
                                        </Tooltip>
                                    </Stack>

                                    <List dense disablePadding sx={appStyles.leftNavList} subheader={<li />}>
                                        <li>
                                            <ul style={{ padding: 0, margin: 0 }}>
                                                <ListSubheader sx={appStyles.leftNavSectionHeader}>
                                                    Home
                                                </ListSubheader>

                                                <ListItemButton
                                                    component={NavLink}
                                                    to={`summary`}
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Summary Report"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/summary_report.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Summary Report" />
                                                    <NavCount count={counts.summary} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="details"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Details"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/details.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Details" />
                                                    <NavCount count={counts.details} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="timeline"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Timeline"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/timeline_white.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Timeline" />
                                                    <NavCount count={counts.timeline} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="web"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Web References"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/web_references.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Web References" />
                                                    <NavCount count={counts.web} />
                                                </ListItemButton>
                                            </ul>
                                        </li>

                                        <li>
                                            <ul style={{ padding: 0, margin: 0 }}>
                                                <ListSubheader sx={appStyles.leftNavSectionHeader}>
                                                    Content
                                                </ListSubheader>

                                                <ListItemButton
                                                    component={NavLink}
                                                    to="pages"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Content Pages"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/content_pages.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Content Pages" />
                                                    <NavCount count={counts.pages} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="series"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Content Series"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/content_series.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Content Series" />
                                                    <NavCount count={counts.series} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="content-resources"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Content Resources"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/content_resources.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Content Resources" />
                                                    <NavCount count={counts.contentResources} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="metadata"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Metadata"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/metadata.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Metadata" />
                                                    <NavCount count={counts.metadata} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="words"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Words"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/words.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Words" />
                                                    <NavCount count={counts.words} />
                                                </ListItemButton>
                                            </ul>
                                        </li>

                                        <li>
                                            <ul style={{ padding: 0, margin: 0 }}>
                                                <ListSubheader sx={appStyles.leftNavSectionHeader}>
                                                    Related
                                                </ListSubheader>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="assoc"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Associations"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/intelligence_associations.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Associations" />
                                                    <NavCount count={counts.assoc} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="resources"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Resource References"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/resources.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Resource References" />
                                                    <NavCount count={counts.resources} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="intel-ref"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Intelligence References"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/intelligence_associations.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Intelligence References" />
                                                    <NavCount count={counts.intelRef} />
                                                </ListItemButton>
                                            </ul>
                                        </li>

                                        <li>
                                            <ul style={{ padding: 0, margin: 0 }}>
                                                <ListSubheader sx={appStyles.leftNavSectionHeader}>
                                                    Analysis
                                                </ListSubheader>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="insight"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Analyst Insight"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/analyst_insight.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Analyst Insight" />
                                                    <NavCount count={counts.insight} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="factors"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Factors"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/factors.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Factors" />
                                                    <NavCount count={counts.factors} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="enrichment"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Enrichment"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/enrichment.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Enrichment" />
                                                    <NavCount count={counts.enrichment} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="research"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Research"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/research.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Research" />
                                                    <NavCount count={counts.research} />
                                                </ListItemButton>
                                            </ul>
                                        </li>

                                        <li>
                                            <ul style={{ padding: 0, margin: 0 }}>
                                                <ListSubheader sx={appStyles.leftNavSectionHeader}>
                                                    Links
                                                </ListSubheader>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="provenance"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Provenance Links"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/provenance.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Provenance Links" />
                                                    <NavCount count={counts.provenance} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to="transactions"
                                                    sx={[appStyles.leftNavItem, appStyles.leftNavItemPink]}
                                                    aria-label="Transactions"
                                                >
                                                    <ListItemIcon sx={appStyles.leftNavItemIcon}>
                                                        <img src="/images/transactions.svg" alt="" aria-hidden="true" width={20} height={20} />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Transactions" />
                                                    <NavCount count={counts.transactions} />
                                                </ListItemButton>
                                            </ul>
                                        </li>
                                    </List>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack
                            direction="column"
                            spacing={2}
                            width="100%"
                            height="100%"
                            alignItems="center"
                        >
                            <Stack
                                sx={{ ...appStyles.defaultPanelContainer, position: "relative" }}
                                direction="row"
                                padding={1}
                                alignItems="center"
                                width="100%"
                            >
                                <Stack direction="column" alignItems="center" width="100%" spacing={0.5} padding={1}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <img
                                            src={`/images/resource_${typeKey}.svg`}
                                            alt=""
                                            aria-hidden="true"
                                            height={32}
                                            onError={(e) => { (e.target as HTMLImageElement).src = "/images/pages_white.svg"; }}
                                        />
                                        <Typography sx={{ fontSize: 16, fontWeight: 600, color: hintColor }}>
                                            {String(matchHash)}
                                        </Typography>
                                    </Stack>
                                    <Typography sx={{ ...appStyles.mainContentTitle, fontSize: 12, opacity: 0.7, textAlign: "center" }}>
                                        Resource Profile
                                    </Typography>
                                </Stack>
                                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ position: "absolute", right: 16 }}>
                                    <img
                                        src={`/images/resource_${typeKey}.svg`}
                                        height={22}
                                        alt=""
                                        aria-hidden="true"
                                        onError={(e) => { (e.target as HTMLImageElement).src = "/images/pages_white.svg"; }}
                                    />
                                    <Typography sx={{ ...appStyles.mainResourceTitle, fontSize: 11, fontWeight: 500, opacity: 0.6 }}>
                                        {String(typeKey)}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Outlet />
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXResourceViewer;
